import React, { createContext, useContext, useState } from "react";

type Store = Record<string, any>;
type StoreApi = {
  setValue: (key: string, value: any) => void;
  getValue: <T = any>(key: string) => T | undefined;
  clearAll: () => void;
};

const SupplierContext = createContext<StoreApi | null>(null);

export const SupplierStoreProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [store, setStore] = useState<Store>({});

  const setValue = (key: string, value: any) => {
    setStore((prev) => ({ ...prev, [key]: value }));
  };

  const getValue = <T,>(key: string) => {
    return store[key] as T;
  };

  const clearAll = () => {
    setStore({});
  };

  return (
    <SupplierContext.Provider value={{ setValue, getValue, clearAll}}>
      {children}
    </SupplierContext.Provider>
  );
};

export const useSupplierContext = () => {
  const ctx = useContext(SupplierContext);
  if (!ctx) throw new Error("useSupplierContext must be used inside SupplierStoreProvider");
  return ctx;
};
